{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "สร้างทีมใหม่",
    "HEADER": "ทีม",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "Teams allow you to organize agents into groups based on their responsibilities. An agent can belong to multiple teams. When working collaboratively, you can assign conversations to specific teams.",
    "LEARN_MORE": "Learn more about teams",
    "COUNT": "{n} team | {n} teams",
    "SEARCH_PLACEHOLDER": "ค้นหาทีม...",
    "NO_RESULTS": "No teams found matching your search",
    "LIST": {
      "404": "ยังไม่มีทีมที่ถูกสร้างในบัญชีนี้",
      "EDIT_TEAM": "แก้ไขทีม",
      "NONE": "ไม่มี"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "สร้างทีมใหม่",
        "DESC": "เพิ่มชื่อและคำอธิบายทีม"
      },
      "AGENTS": {
        "BUTTON_TEXT": "เพิ่มพนักงานเข้าทีม",
        "TITLE": "เพิ่มพนักงานเข้าทีม {teamName}",
        "DESC": "เพิ่มพนักงานเข้าทีมที่สร้างใหม่ของคุณ ซึ่งจะช่วยให้คุณทำงานร่วมกันเป็นทีมเพื่อตอบรับการสนทนาและรับการแจ้งเตือนจากการสนทนาเดียวกัน"
      },
      "WIZARD_CREATE": {
        "TITLE": "สร้าง",
        "BODY": "สร้างทีมใหม่สำหรับพนักงาน"
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "เพิ่มพนักงาน",
        "BODY": "เพิ่มพนักงานเข้าทีม"
      },
      "WIZARD_FINISH": {
        "TITLE": "เสร็จสิ้น",
        "BODY": "คุณพร้อมเเล้ว"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "แก้ไขรายละเอียดของทีม",
        "DESC": "แก้ไขชื่อและคำอธิบายทีม",
        "BUTTON_TEXT": "อัปเดตทีม"
      },
      "AGENTS": {
        "BUTTON_TEXT": "อัพเดทพนักงานในทีม",
        "TITLE": "เพิ่มพนักงานเข้าทีม {teamName}",
        "DESC": "เพิ่มพนักงานเข้าทีมที่สร้างใหม่ของคุณ พนักงานทุกคนในทีมจะได้รับการแจ้งเตือนเมื่อทีมได้รับมอบหมายให้ดูแลการสนทนา"
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "รายละเอียดของทีม",
        "ROUTE": "settings_teams_edit",
        "BODY": "เปลี่ยนชื่อ คำอธิบาย และรายละเอียดอื่นๆ"
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "เเก้ไขพนักงาน",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "แก้ไขพนักงานในทีมของคุณ"
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "เสร็จสิ้น",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "คุณพร้อมเเล้ว"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "ไม่สามารถบันทึกรายละเอียดของทีมได้ โปรดลองใหม่อีกครั้ง"
    },
    "AGENTS": {
      "AGENT": "พนักงาน",
      "EMAIL": "อีเมล์",
      "BUTTON_TEXT": "เพิ่มพนักงาน",
      "ADD_AGENTS": "กำลังเพิ่มพนักงานเข้าทีมของคุณ...",
      "SELECT": "เลือก",
      "SELECT_ALL": "เลือกพนักงานทั้งหมด",
      "SELECTED_COUNT": "เลือก {selected} จากพนักงานทั้งหมด {total} คน"
    },
    "ADD": {
      "TITLE": "เพิ่มพนักงานเข้าทีม {teamName}",
      "DESC": "เพิ่มพนักงานเข้าทีมที่สร้างใหม่ของคุณ ซึ่งจะช่วยให้คุณทำงานร่วมกันเป็นทีมเพื่อตอบรับการสนทนาและรับการแจ้งเตือนจากการสนทนาเดียวกัน",
      "SELECT": "เลือก",
      "SELECT_ALL": "เลือกพนักงานทั้งหมด",
      "SELECTED_COUNT": "เลือก {selected} จากพนักงานทั้งหมด {total} คน",
      "BUTTON_TEXT": "เพิ่มพนักงาน",
      "AGENT_VALIDATION_ERROR": "เลือกพนักงานอย่างน้อย 1 คน"
    },
    "FINISH": {
      "TITLE": "ทีมของคุณพร้อมแล้ว!",
      "MESSAGE": "ตอนนี้ทีมของคุณสามารถทำงานร่วมกันเพื่อดูแลการสนทนา ขอให้สนุกกับการทำงาน ",
      "BUTTON_TEXT": "เสร็จสิ้น"
    },
    "DELETE": {
      "BUTTON_TEXT": "ลบ",
      "API": {
        "SUCCESS_MESSAGE": "ลบทีมสำเร็จแล้ว",
        "ERROR_MESSAGE": "ไม่สามารถลบทีมได้ โปรดลองใหม่อีกครั้ง"
      },
      "CONFIRM": {
        "TITLE": "Are you sure you want to delete the team?",
        "PLACE_HOLDER": "โปรดพิมพ์ {teamName} เพื่อยืนยัน",
        "MESSAGE": "การลบทีมจะยกเลิกการมอบหมายการสนทนาที่ทีมนี้รับผิดชอบไปด้วย",
        "YES": "ลบ ",
        "NO": "ยกเลิก"
      }
    },
    "SETTINGS": "ตั้งค่า",
    "FORM": {
      "UPDATE": "อัปเดตทีม",
      "CREATE": "สร้างทีม",
      "NAME": {
        "LABEL": "ชื่อทีม",
        "PLACEHOLDER": "เช่น ฝ่ายขาย ฝ่ายสนับสนุนลูกค้า"
      },
      "DESCRIPTION": {
        "LABEL": "คำอธิบายทีม",
        "PLACEHOLDER": "คำอธิบายสั้นๆเกี่ยวกับทีม"
      },
      "AUTO_ASSIGN": {
        "LABEL": "เปิดใช้การมอบหมายงานอัตโนมัติสำหรับทีมนี้"
      },
      "SUBMIT_CREATE": "สร้างทีม"
    }
  }
}
